import { defineComponent as _, useCssModule as $, inject as B, createElementBlock as h, openBlock as b, normalizeClass as d, unref as a, createElementVNode as n, toDisplayString as y, withDirectives as M, vShow as x, renderSlot as k, computed as c, createBlock as g, resolveDynamicComponent as N, withCtx as D } from "vue";
import { R as W } from "./RadioGroup.keys-CqfiKkNz.js";
import { _ as w } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const E = ["id", "name", "value", "checked", "disabled"], R = ["for"], T = /* @__PURE__ */ _({
  __name: "VariantButton",
  props: {
    disabled: { type: Boolean },
    fullWidth: { type: Boolean },
    id: {},
    label: {},
    modelValue: {},
    name: {},
    value: {}
  },
  emits: ["input"],
  setup(s, { emit: u }) {
    const e = s, l = $(), t = B(W.key), r = u;
    return (o, i) => {
      var m, v;
      return b(), h("div", {
        "data-variant-button": "",
        class: d([
          a(l).root,
          {
            "tw-w-full": e.fullWidth,
            [a(l)["radio-group-vertical-orientation"]]: ((v = (m = a(t)) == null ? void 0 : m.orientation) == null ? void 0 : v.value) === "vertical"
          }
        ])
      }, [
        n("input", {
          id: `${e.name}-${e.id}`,
          class: d(["tw-sr-only", a(l).input]),
          type: "radio",
          name: e.name,
          value: e.value,
          checked: e.modelValue === e.value,
          disabled: e.disabled || e.disabled,
          onInput: i[0] || (i[0] = (V) => r("input", V))
        }, null, 42, E),
        n("label", {
          class: d(a(l).label),
          for: `${e.name}-${e.id}`
        }, y(e.label), 11, R)
      ], 2);
    };
  }
}), q = "_label_6w0bq_2", O = "_root_6w0bq_14", S = "_input_6w0bq_36", z = {
  label: q,
  root: O,
  "radio-group-vertical-orientation": "_radio-group-vertical-orientation_6w0bq_32",
  input: S
}, A = {
  $style: z
}, F = /* @__PURE__ */ w(T, [["__cssModules", A]]), J = ["id", "name", "value", "checked", "disabled"], P = ["for"], U = /* @__PURE__ */ _({
  __name: "VariantChip",
  props: {
    disabled: { type: Boolean },
    fullWidth: { type: Boolean },
    id: {},
    label: {},
    modelValue: {},
    name: {},
    value: {}
  },
  emits: ["input"],
  setup(s, { emit: u }) {
    const e = s, l = $(), t = u;
    return (r, o) => (b(), h("div", {
      class: d([a(l).root, { "tw-w-full": e.fullWidth }])
    }, [
      n("input", {
        id: `${e.name}-${e.id}`,
        class: d(["tw-sr-only", a(l).input]),
        type: "radio",
        name: e.name,
        value: e.value,
        checked: e.modelValue === e.value,
        disabled: e.disabled || e.disabled,
        onInput: o[0] || (o[0] = (i) => t("input", i))
      }, null, 42, J),
      n("label", {
        class: d(a(l).label),
        for: `${e.name}-${e.id}`
      }, y(e.label), 11, P)
    ], 2));
  }
}), H = "_label_vdpts_2", K = "_input_vdpts_16", L = {
  label: H,
  input: K
}, Q = {
  $style: L
}, X = /* @__PURE__ */ w(U, [["__cssModules", Q]]), Y = ["id", "name", "value", "checked", "disabled"], Z = ["for"], I = /* @__PURE__ */ _({
  __name: "VariantRadio",
  props: {
    disabled: { type: Boolean },
    fullWidth: { type: Boolean },
    id: {},
    label: {},
    modelValue: {},
    name: {},
    value: {}
  },
  emits: ["input"],
  setup(s, { emit: u }) {
    const e = s, l = $(), t = u;
    return (r, o) => (b(), h("div", {
      class: d(["tw-flex", [a(l).root, { "tw-w-full": e.fullWidth }]])
    }, [
      n("input", {
        id: `${e.name}-${e.id}`,
        class: d(a(l).input),
        type: "radio",
        name: e.name,
        value: e.value,
        checked: e.modelValue === e.value,
        disabled: e.disabled,
        onInput: o[0] || (o[0] = (i) => t("input", i))
      }, null, 42, Y),
      M(n("label", {
        class: d([a(l).label, { "tw-text-ice-500": e.disabled }]),
        for: `${e.name}-${e.id}`
      }, y(e.label), 11, Z), [
        [x, e.label]
      ])
    ], 2));
  }
}), j = "_label_kw8hn_2", G = "_input_kw8hn_9", ee = {
  label: j,
  input: G
}, le = {
  $style: ee
}, te = /* @__PURE__ */ w(I, [["__cssModules", le]]), ae = ["for"], se = ["id", "aria-labelledby", "name", "value", "checked", "disabled"], de = ["id"], oe = /* @__PURE__ */ _({
  __name: "VariantTile",
  props: {
    disabled: { type: Boolean },
    fullWidth: { type: Boolean },
    id: {},
    label: {},
    modelValue: {},
    name: {},
    value: {}
  },
  emits: ["input"],
  setup(s, { emit: u }) {
    const e = s, l = $(), t = u;
    return (r, o) => (b(), h("label", {
      class: d([a(l).root, { "tw-w-full": e.fullWidth, [a(l)["root--disabled"]]: e.disabled }]),
      for: `${e.name}-${e.id}`
    }, [
      n("div", {
        class: d(["tw-flex tw-border", [
          a(l)["tile-header"],
          {
            "tw-border-blue-500 tw-bg-blue-100": e.modelValue === e.value && !e.disabled,
            "tw-border-ice-500 tw-bg-ice-100": e.modelValue !== e.value || e.disabled
          }
        ]])
      }, [
        n("input", {
          id: `${e.name}-${e.id}`,
          "aria-labelledby": `tile-label-${e.name}-${e.id}`,
          class: d(["tw-sr-only", a(l).input]),
          type: "radio",
          name: e.name,
          value: e.value,
          checked: e.modelValue === e.value,
          disabled: e.disabled,
          onInput: o[0] || (o[0] = (i) => t("input", i))
        }, null, 42, se),
        n("div", {
          id: `tile-label-${e.name}-${e.id}`,
          class: d([a(l).label, { "tw-text-ice-500": e.disabled }])
        }, y(e.label), 11, de)
      ], 2),
      n("div", {
        class: d([
          a(l)["tile-body"],
          {
            "tw-border-ice-500": e.modelValue !== e.value || e.disabled,
            "tw-border-blue-500": e.modelValue === e.value && !e.disabled
          }
        ])
      }, [
        k(r.$slots, "default")
      ], 2)
    ], 10, ae));
  }
}), ie = "_root_583pa_2", ne = "_label_583pa_32", ue = "_input_583pa_39", re = {
  root: ie,
  "root--disabled": "_root--disabled_583pa_11",
  "tile-header": "_tile-header_583pa_15",
  "tile-body": "_tile-body_583pa_16",
  label: ne,
  input: ue
}, ce = {
  $style: re
}, pe = /* @__PURE__ */ w(oe, [["__cssModules", ce]]);
var p = /* @__PURE__ */ ((s) => (s.Radio = "radio", s.Button = "button", s.Chip = "chip", s.Tile = "tile", s))(p || {});
const fe = /* @__PURE__ */ _({
  __name: "RadioNew",
  props: {
    name: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    id: { default: void 0 },
    modelValue: { default: void 0 },
    hasError: { type: Boolean, default: !1 },
    label: { default: "" },
    variant: { default: void 0 },
    value: {}
  },
  emits: ["update:modelValue"],
  setup(s, { emit: u }) {
    const e = {
      [p.Button]: F,
      [p.Chip]: X,
      [p.Radio]: te,
      [p.Tile]: pe
    }, l = B(W.key, null), t = s, r = c(() => t.modelValue || (l == null ? void 0 : l.modelValue.value)), o = c(() => t.name || (l == null ? void 0 : l.name.value)), i = c(() => t.fullWidth || (l == null ? void 0 : l.fullWidth.value)), m = c(() => t.disabled || (l == null ? void 0 : l.disabled.value)), v = c(() => t.variant || (l == null ? void 0 : l.variant.value) || "radio"), V = u;
    function C(f) {
      if (l != null && l.update) {
        l.update(f);
        return;
      }
      V("update:modelValue", f.target.value);
    }
    return (f, _e) => (b(), g(N(e[v.value]), {
      id: t.id,
      disabled: m.value,
      "has-error": t.hasError,
      "full-width": i.value,
      label: t.label,
      "model-value": r.value,
      name: o.value,
      value: t.value,
      onInput: C
    }, {
      default: D(() => [
        k(f.$slots, "default")
      ]),
      _: 3
    }, 40, ["id", "disabled", "has-error", "full-width", "label", "model-value", "name", "value"]));
  }
});
export {
  p as RadioVariant,
  fe as default
};
//# sourceMappingURL=RadioNew.js.map
